import { render } from "./SideMenu.vue?vue&type=template&id=79f86886&ts=true"
import script from "./SideMenu.vue?vue&type=script&lang=ts"
export * from "./SideMenu.vue?vue&type=script&lang=ts"

import "./SideMenu.vue?vue&type=style&index=0&id=79f86886&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/SideMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "79f86886"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('79f86886', __exports__)) {
    api.reload('79f86886', __exports__)
  }
  
  module.hot.accept("./SideMenu.vue?vue&type=template&id=79f86886&ts=true", () => {
    api.rerender('79f86886', render)
  })

}


export default __exports__